import classNames from "classnames";
import React from "react";
import { Icon, Icomoon } from "../..";
import "./StarInput.scss";

interface Props {
  value: number;
  max?: number;
  className?: string;
  onChange?: (value: number) => void;
  ratingDescriptions?: string[];
  readonly?: boolean;
}

/**
 * Input for a star rating.
 * 
 * @status stable
 */
export class StarInput extends React.Component<Props> {
  static defaultProps = {
    max: 5,
  };

  setValue(newValue: number) {
    if (!this.props.readonly) {
      this.props.onChange?.(newValue);
    }
  }

  getDescription() {
    if (!this.props.value) {
      return "Unrated";
    }

    const ratingDescriptions = this.props.ratingDescriptions ?? ["Very poor", "Poor", "Average", "Good", "Very good"];
    return ratingDescriptions[this.props.value - 1];
  }

  render() {
    const starInputs = [];
    const max = this.props.max ?? 5;
    const value = this.props.value;

    for (let i = 0; i < max; i++) {
      starInputs.push((
        <div
          key={i}
          className="star-input__star"
          onClick={() => this.setValue(i + 1)}>
          <Icon icomoon={(!value || i >= value) ? Icomoon.starEmpty3 : Icomoon.starFull2} />
        </div>
      ));
    }

    return (
      <div className={classNames("star-input", { "readonly": this.props.readonly })}>
        {starInputs}
        <label className="m-left-xsmall">{this.getDescription()}</label>
      </div>
    );
  }
}
